/* eslint-disable no-underscore-dangle */
import { Checkbox, Row, Col, Select } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import Enums from 'utils/EnumsManager';
import { Buttons, ConditionLogic, Filters } from './components/index';
import Sider from './components/Sider';
import styles from './index.less';

const { Option } = Select;
const cx = classNames.bind(styles);

const CheckboxGroup = Checkbox.Group;

const ClientTypes = [
  Enums.ObjectTypes.Leads,
  Enums.ObjectTypes.Accounts,
  Enums.ObjectTypes.Opportunities,
];

const defaultProps = {
  conditions: [],
  fields: [],
  filters: [],
  valueTypeOptions: [],
  logicText: '',
  enableTopSelection: false,
  enableCheckbox: false,
  theme: '',
  rightSiderValue: {},
  handleTimeRangeChange: () => {},
  hadleSiderClose: null,
};
const propTypes = {
  theme: PropTypes.string,
  logicText: PropTypes.string,
  conditions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  valueTypeOptions: PropTypes.array,
  fields: PropTypes.array,
  // TODO: add function props checking to verify that each filter follow the same shape
  filters: PropTypes.array,
  handleAddNewClick: PropTypes.func.isRequired,
  handleLogicChange: PropTypes.func.isRequired,
  handleFilterRemove: PropTypes.func.isRequired,
  enableTopSelection: PropTypes.bool,
  enableCheckbox: PropTypes.bool,
  handleTimeRangeChange: PropTypes.func,
  hadleSiderClose: PropTypes.func,
  rightSiderValue: PropTypes.object,
};

class FilterCriteria extends Component {
  _handleAddNewClick = () => {
    const { handleAddNewClick } = this.props;
    if (_.isFunction(handleAddNewClick)) {
      return handleAddNewClick();
    }
  }

  _handleLogicChange = (value) => {
    const { handleLogicChange } = this.props;
    if (_.isFunction(handleLogicChange)) {
      return handleLogicChange(value);
    }
  }

  _onUserTypeChange = (value) => {
    const { onUserTypeChange } = this.props;
    if (_.isFunction(onUserTypeChange)) {
      return onUserTypeChange(value);
    }
  }

  _handleCheckboxChange = (e) => {
    const { handleCheckboxChange } = this.props;
    if (_.isFunction(handleCheckboxChange)) {
      return handleCheckboxChange(e.target.checked);
    }
  }

  _handleFieldChange = (fieldId, displayNum) => {
    const { handleFieldChange } = this.props;
    if (_.isFunction(handleFieldChange)) {
      return handleFieldChange(fieldId, displayNum);
    }
  }

  _handleConditionChange = (fieldId, displayNum) => {
    const { handleConditionChange } = this.props;
    if (_.isFunction(handleConditionChange)) {
      return handleConditionChange(fieldId, displayNum);
    }
  }

  _handleValueChange = (value, displayNum) => {
    const { handleValueChange } = this.props;
    if (_.isFunction(handleValueChange)) {
      return handleValueChange(displayNum, value);
    }
  }

  _handleAddonClick = (displayNum) => {
    const { handleAddonClick } = this.props;
    if (_.isFunction(handleAddonClick)) {
      return handleAddonClick(displayNum);
    }
  }

  _handleSiderClose = () => {
    const { handleSiderClose } = this.props;
    if (_.isFunction(handleSiderClose)) {
      return handleSiderClose();
    }
  }

  _handleFilterRemove = (displayNum) => {
    const { handleFilterRemove } = this.props;
    if (_.isFunction(handleFilterRemove)) {
      return handleFilterRemove(displayNum);
    }
  }

  _handleSiderValuesChange = (checkedValues) => {
    const { handleSiderValuesChange } = this.props;
    if (_.isFunction(handleSiderValuesChange)) {
      return handleSiderValuesChange(checkedValues);
    }
  }

  _handleInsertSelection = () => {
    const { handleInsertSelection } = this.props;
    if (_.isFunction(handleInsertSelection)) {
      return handleInsertSelection();
    }
  }

  _handleTimeRangeChange = (displayNum, prop, newValue) => {
    const func = this.props.handleTimeRangeChange;
    if (_.isFunction(func)) {
      func(displayNum, prop, newValue);
    }
  }

  _handleValueTypeChange = (displayNum, valueType) => {
    const { handleValueTypeChange } = this.props;
    if (_.isFunction(handleValueTypeChange)) {
      handleValueTypeChange(valueType, displayNum);
    }
  }

  render() {
    const {
      theme,
      logicText,
      fields,
      filters,
      conditions,
      rightSiderValue,
      valueTypeOptions,
      getCompareOptions,
      enableTopSelection,
      hadleSiderClose,
      enableCheckbox,
      collapsed,
      siderSelection,
    } = this.props;

    return (
      <Fragment>
        {enableTopSelection && (
          <Row>
            <div>From</div>
            <Select size="small" style={{ width: '100%', marginBottom: 30 }} onChange={this._onUserTypeChange}>
              {ClientTypes.map(type => <Option key={type} value={type}>{type}</Option>)}
            </Select>
          </Row>
        )}
        <Row>
          <Filters
            filters={filters}
            fields={fields}
            conditions={conditions}
            valueTypeOptions={valueTypeOptions}
            getCompareOptions={getCompareOptions}
            handleFieldChange={this._handleFieldChange}
            handleConditionChange={this._handleConditionChange}
            handleValueTypeChange={this._handleValueTypeChange}
            handleValueChange={this._handleValueChange}
            handleAddonClick={this._handleAddonClick}
            handleFilterRemove={this._handleFilterRemove}
            handleTimeRangeChange={this._handleTimeRangeChange}
          />
        </Row>
        <Row style={{ textAlign: 'center', margin: '10px 0' }}>
          <Buttons theme={theme} handleAddClick={this._handleAddNewClick} />
        </Row>
        <Row>
          <ConditionLogic
            value={logicText}
            handleChange={this._handleLogicChange}
            hasError={logicText === '' && filters.length > 0}
          />
        </Row>
        {/* Due to the mutiple render and function error, the sider component will be moved to the top compoent of page which use it */}
        {/* <Sider
          rightSiderValue={rightSiderValue}
          hadleSiderClose={hadleSiderClose}
          handleValueChange={this._handleValueChange}
        /> */}
      </Fragment>
    );
  }
}

FilterCriteria.defaultProps = defaultProps;
FilterCriteria.propTypes = propTypes;
export default FilterCriteria;



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria/index.jsx